// extracted by mini-css-extract-plugin
export default {"root":"msvcD7","fullScreen":"POIjkx","popover":"xhEhU0"};